import {StyledContainerMobileTable} from '@/features/measures/components/table/measure-table-mobile/style.ts'
import {MeasureCard} from '@/features/measures/components/measure-card/MeasureCard.tsx'
import {Measure} from '@/features/measures/services/types.ts'
import {TablePagination} from '@components/ui/table-atoms/TableAtoms.tsx'
import {FC} from 'react'
import {MetaProps} from '@/types.ts'
import {EmptySearch} from '@components/commons/empty-search/EmptySearch.tsx'
import {useTranslation} from 'react-i18next'
import {FileTextIcon} from '@components/ui/icon/Icon.tsx'

interface MeasureTableMobileProps {
    measures: Measure[]
    isLoading: boolean
    meta: MetaProps
    setCurrentPage: (page: number) => void
    perPage: number
    setPerPage: (perPage: number) => void
}

export const MeasureTableMobile: FC<MeasureTableMobileProps> = ({
    measures,
    isLoading,
    meta,
    setCurrentPage,
    perPage,
    setPerPage
}) => {
    const {t} = useTranslation()

    if (!measures.length && !isLoading) {
        return (
            <EmptySearch
                icon={<FileTextIcon fill="none" />}
                title={t('measures:no_measures')}
                subtitle={t('measures:try_different_filters')}
            />
        )
    }

    return (
        <>
            <StyledContainerMobileTable
                data={isLoading ? Array(5).fill(null) : measures}
                overscan={100}
                itemContent={(itemIndex, item) => {
                    return (
                        <MeasureCard
                            measure={item as Measure}
                            key={itemIndex}
                            isLoading={isLoading}
                            setCurrentPage={setCurrentPage}
                            setPerPage={setPerPage}
                        />
                    )
                }}
                style={{
                    width: '100%'
                }}
            />

            <TablePagination
                isLoading={isLoading}
                pagination={{
                    limit: perPage,
                    currentPage: meta?.currentPage || 1,
                    total: meta?.total || 100,
                    onChangePage: setCurrentPage
                }}
            />
        </>
    )
}
